// // src/pages/LoanCardPage.jsx
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/LoanEmiSlice";
// import { fetchLoanReports } from "../redux/slices/loanReportSlice";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import "../css/LoanCardPage.css";

// // Utility: format date as DD-MM-YYYY
// const formatDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   if (isNaN(date)) return dateStr;
//   return date.toLocaleDateString("en-GB");
// };

// // Utility: format amount as Rs XXXX
// const formatAmount = (amount) => {
//   if (!amount || isNaN(amount)) return "Rs 0";
//   return `Rs ${Number(amount).toLocaleString("en-IN")}`;
// };

// const LoanCardPage = () => {
//   const { loanId } = useParams();
//   const dispatch = useDispatch();

//   const { emis, loading, error } = useSelector((state) => state.loanEmi);
//   const { loans, loadingloan, errorloan } = useSelector(
//     (state) => state.loanReport
//   );

//   const [company, setCompany] = useState(null);
//   const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//   // Fetch EMIs, Loans and Company Info on mount
//   useEffect(() => {
//     if (loanId) {
//       dispatch(fetchLoanEmis(loanId));
//       dispatch(fetchLoanReports());
//     }

//     // Fetch company details
//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(
//           `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
//         );
//         const data = await res.json();
//         if (res.ok && data) {
//           if (data.logo) {
//             data.logoUrl = `https://payyug.in/${data.logo.replace(
//               /^images\//,
//               ""
//             )}`;
//           }
//           setCompany(data);
//         }
//       } catch (err) {
//         console.error("Error fetching company details:", err);
//       }
//     };

//     if (superAdminId) fetchCompany();

//     return () => dispatch(clearLoanEmis());
//   }, [dispatch, loanId, superAdminId]);

//   const loan = loans?.find((l) => String(l.id) === String(loanId)) || null;
//   const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";

//   // ✅ Download PDF with sequential EMIs & logo in header
//   const downloadPageAsPDF = async () => {
//     if (!loan) return;

//     const doc = new jsPDF("p", "mm", "a4");
//     const margin = 14;
//     let y = 20;

//     // ---------- HEADER ----------
//     if (company?.logoUrl) {
//       try {
//         const img = await fetch(company.logoUrl);
//         const blob = await img.blob();
//         const reader = new FileReader();
//         reader.onload = function (e) {
//           const imgData = e.target.result;
//           doc.addImage(imgData, "PNG", margin, y, 30, 30); // Logo
//           doc.setFontSize(16);
//           doc.setFont("helvetica", "bold");
//           doc.text(company?.name || "Company Name", margin + 40, y + 10);
//           doc.setFontSize(10);
//           doc.setFont("helvetica", "normal");
//           doc.text(company?.address || "Company Address", margin + 40, y + 16);
//           doc.text(
//             `Phone: ${company?.contact || "-"} | Email: ${
//               company?.email || "-"
//             }`,
//             margin + 40,
//             y + 22
//           );
//           finishPDF();
//         };
//         reader.readAsDataURL(blob);
//       } catch (e) {
//         console.error("Logo load error:", e);
//         finishPDF(); // fallback without logo
//       }
//     } else {
//       finishPDF();
//     }

//     function finishPDF() {
//       y += 40;
//       doc.setDrawColor(150);
//       doc.line(margin, y, 200, y);
//       y += 10;

//       // ---------- CUSTOMER & LOAN DETAILS ----------
//       doc.setFontSize(13);
//       doc.setFont("helvetica", "bold");
//       doc.text("Customer & Loan Details", margin, y);
//       y += 8;

//       doc.setFontSize(11);
//       doc.setFont("helvetica", "normal");
//       doc.text(`Customer Name: ${loan.userName}`, margin, y);
//       doc.text(`Loan No: ${loan.loanAccountNumber}`, 120, y);
//       y += 6;

//       doc.text(`Guardian: ${loan.guardianName || "NA"}`, margin, y);
//       doc.text(`Branch: ${loan.branch || "NA"}`, 120, y);
//       y += 6;

//       doc.text(`Contact: ${loan.contactNo || "-"}`, margin, y);
//       doc.text(`Plan: ${loan.loanType || loan.planName || "NA"}`, 120, y);
//       y += 6;

//       doc.text(`Loan Amount: ${formatAmount(loan.loanAmount)}`, margin, y);
//       doc.text(`EMI Amount: ${formatAmount(emiAmountFromSchedule)}`, 120, y);
//       y += 6;

//       doc.text(`Number of EMI: ${emis.length}`, margin, y);
//       doc.text(
//         `Exit Amount: ${formatAmount(loan.exitAmount || loan.loanPayable)}`,
//         120,
//         y
//       );
//       y += 10;

//       // ---------- EMI TABLE (auto page break by autoTable) ----------
//       const tableData = emis.map((emi, i) => [
//         i + 1,
//         formatDate(emi.dueDate),
//         formatAmount(emi.principalComponent),
//         formatAmount(emi.interestComponent),
//         formatAmount(emi.emiAmount),
//         emi.paymentDate ? formatDate(emi.paymentDate) : "-",
//         "", // Staff Sign
//         "", // Customer Sign
//       ]);

//       autoTable(doc, {
//         startY: y,
//         head: [
//           [
//             "EMI No",
//             "Due Date",
//             "Principal",
//             "Interest",
//             "EMI Amount",
//             "Paid Date",
//             "Staff Sign",
//             "Customer Sign",
//           ],
//         ],
//         body: tableData,
//         styles: { fontSize: 9 },
//         theme: "grid",
//         headStyles: { fillColor: [255, 145, 155], textColor: 0 },
//         margin: { left: margin, right: margin },
//       });

//       doc.save(`LoanCard_${loan.loanAccountNumber || loan.loanNumber}.pdf`);
//     }
//   };

//   if (loading || loadingloan)
//     return <div className="AdminLoanCardPage-loading">Loading...</div>;
//   if (error || errorloan)
//     return (
//       <div className="AdminLoanCardPage-error">{error || errorloan}</div>
//     );
//   if (!loan)
//     return (
//       <div className="AdminLoanCardPage-empty">
//         No loan found for Loan ID {loanId}
//       </div>
//     );

//   return (
//     <div className="AdminLoanCardPage-container">
//      <header className="AdminLoanCardPage-header">
//   <div className="LoanCard-logo-container">
//     {company?.logoUrl && (
//       <img src={company.logoUrl} alt="Logo" className="LoanCard-logo" />
//     )}
//   </div>
//   <div className="LoanCard-company-info">
//     <h1 className="company-name">{company?.name || "Company Name"}</h1>
//     {company?.cin && <p><strong>CIN:</strong> {company.cin}</p>}
//     {company?.address && <p><strong>Address:</strong> {company.address}</p>}
//     {company?.email && <p><strong>Email:</strong> {company.email}</p>}
//     {company?.contact && <p><strong>Contact:</strong> {company.contact}</p>}
//   </div>
//   <div className="LoanCard-title">
//     <h2>Loan Card</h2>
//   </div>
// </header>

//       {/* Loan & Customer Details */}
//       <section className="AdminLoanCardPage-details">
//         <div>
//           <strong>Customer Name:</strong> {loan.userName}
//         </div>
//         <div>
//           <strong>Guardian Name:</strong> {loan.guardianName || "NA"}
//         </div>
//         <div>
//           <strong>Loan Number:</strong> {loan.loanAccountNumber}
//         </div>
//         <div>
//           <strong>Branch:</strong> {loan.branch || "NA"}
//         </div>
//         <div>
//           <strong>Contact No:</strong> {loan.contactNo || "-"}
//         </div>
//         <div>
//           <strong>Plan Name:</strong> {loan.loanType || loan.planName || "NA"}
//         </div>
//         <div>
//           <strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}
//         </div>
//         <div>
//           <strong>EMI Amount:</strong> {formatAmount(emiAmountFromSchedule)}
//         </div>
//         <div>
//           <strong>Number of EMI:</strong> {emis.length}
//         </div>
//         <div>
//           <strong>Exit Amount:</strong> {formatAmount(loan.loanPayable)}
//         </div>
//       </section>

//       {/* EMI Schedule */}
//       <section className="AdminLoanCardPage-table">
//         <h2 className="loan-card-page-header">EMI Schedule</h2>
//         <table>
//           <thead>
//             <tr>
//               <th>EMI No</th>
//               <th>Due Date</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>EMI Amount</th>
//               <th>Payment Date</th>
//               <th>Staff Sign</th>
//               <th>Customer Sign</th>
//             </tr>
//           </thead>
//           <tbody>
//             {emis.map((emi, index) => (
//               <tr key={emi.id}>
//                 <td>{index + 1}</td>
//                 <td>{formatDate(emi.dueDate)}</td>
//                 <td>{formatAmount(emi.principalComponent)}</td>
//                 <td>{formatAmount(emi.interestComponent)}</td>
//                 <td>{formatAmount(emi.emiAmount)}</td>
//                 <td>{emi.paymentDate ? formatDate(emi.paymentDate) : "-"}</td>
//                 <td></td>
//                 <td></td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </section>

//       {/* Download Button */}
//       <div className="AdminLoanCardPage-btn-wrapper ">
//         <button
//           className="AdminLoanCardPage-download-btn"
//           onClick={downloadPageAsPDF}
//         >
//           📥 Download PDF
//         </button>
//       </div>
//     </div>
//   );
// };

// export default LoanCardPage;

// src/pages/LoanCardPage.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/LoanEmiSlice";
import { fetchLoanReports } from "../redux/slices/loanReportSlice";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../css/LoanCardPage.css";

// Utility: format date as DD-MM-YYYY
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  return date.toLocaleDateString("en-GB");
};

// Utility: format amount as Rs XXXX
const formatAmount = (amount) => {
  if (!amount || isNaN(amount)) return "Rs 0";
  return `Rs ${Number(amount).toLocaleString("en-IN")}`;
};

const LoanCardPage = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();

  const { emis, loading, error } = useSelector((state) => state.loanEmi);
  const { loans, loadingloan, errorloan } = useSelector(
    (state) => state.loanReport
  );

  const [company, setCompany] = useState(null);
  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  // Fetch EMIs, Loans, and Company Info
  useEffect(() => {
    if (loanId) {
      dispatch(fetchLoanEmis(loanId));
      dispatch(fetchLoanReports());
    }

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(
              /^images\//,
              ""
            )}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();

    return () => dispatch(clearLoanEmis());
  }, [dispatch, loanId, superAdminId]);

  const loan = loans?.find((l) => String(l.id) === String(loanId)) || null;
  const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";

  // ✅ Download PDF
  const downloadPageAsPDF = async () => {
    if (!loan) return;
    const doc = new jsPDF("p", "mm", "a4");
    const margin = 14;
    let y = 20;

    
    // ---------- HEADER ----------
    const pageWidth = doc.internal.pageSize.getWidth();
    const centerX = pageWidth / 2;

    if (company?.logoUrl) {
      try {
        const img = await fetch(company.logoUrl);
        const blob = await img.blob();
        const reader = new FileReader();

        reader.onload = function (e) {
          const imgData = e.target.result;

          // --- Logo (Left - Circular Look) ---
          doc.addImage(imgData, "PNG", margin, y, 30, 30);

          // Optional circle border around logo
          doc.setDrawColor(200);
          doc.circle(margin + 15, y + 15, 16);

          // --- Company Name (Center) ---
          doc.setFont("helvetica", "bold");
          doc.setFontSize(16);
          doc.text(company?.name || "Company Name", centerX, y + 8, {
            align: "center",
          });

          // --- Company Details ---
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          if (company?.cin)
            doc.text(`CIN: ${company.cin}`, centerX, y + 16, { align: "center" });

          if (company?.address)
            doc.text(
              `Regt. Office: ${company.address}`,
              centerX,
              y + 22,
              { align: "center" }
            );

          doc.text(
            `Email: ${company?.email || "-"}`,
            centerX,
            y + 28,
            { align: "center" }
          );

          doc.text(
          `Ph: ${company?.contact || "-"}`,
          centerX,
          y + 34,
          { align: "center" }
          );

          // Divider line
          y += 38;
          doc.setDrawColor(180);
          doc.line(margin, y, pageWidth - margin, y);

          // Title
          y += 10;
          doc.setFont("helvetica", "bold");
          doc.setFontSize(14);
          doc.text("LOAN CARD", centerX, y, { align: "center" });

          // y += 8;
          // doc.setDrawColor(0);
          // doc.line(margin, y, pageWidth - margin, y);

          y += 10;
          printBody();
        };

        reader.readAsDataURL(blob);
      } catch (e) {
        console.error("Logo load error:", e);
        printBody();
      }
    } else {
      printBody();
    }


    function printBody() {
      doc.setFontSize(13);
      doc.setFont("helvetica", "bold");
      doc.text("Customer & Loan Details", margin, y);
      y += 8;

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(`Customer Name: ${loan.userName}`, margin, y);
      doc.text(`Loan No: ${loan.loanAccountNumber}`, 120, y);
      y += 6;
      // doc.text(`Guardian: ${loan.guardianName || "NA"}`, margin, y);
      doc.text(`Branch: ${loan.branch || "NA"}`, 120, y);
      y += 6;
      // doc.text(`Contact: ${loan.contactNo || "-"}`, margin, y);
      doc.text(`Plan: ${loan.loanType || loan.planName || "NA"}`, 120, y);
      y += 6;
      doc.text(`Loan Amount: ${formatAmount(loan.loanAmount)}`, margin, y);
      doc.text(`EMI Amount: ${formatAmount(emiAmountFromSchedule)}`, 120, y);
      y += 6;
      doc.text(`Number of EMI: ${emis.length}`, margin, y);
      doc.text(
        `Exit Amount: ${formatAmount(loan.exitAmount || loan.loanPayable)}`,
        120,
        y
      );
      y += 10;

      const tableData = emis.map((emi, i) => [
        i + 1,
        formatDate(emi.dueDate),
        formatAmount(emi.principalComponent),
        formatAmount(emi.interestComponent),
        formatAmount(emi.emiAmount),
        emi.paymentDate ? formatDate(emi.paymentDate) : "-",
        "",
        "",
      ]);

      autoTable(doc, {
        startY: y,
        head: [
          [
            "EMI No",
            "Due Date",
            "Principal",
            "Interest",
            "EMI Amount",
            "Paid Date",
            "Staff Sign",
            "Customer Sign",
          ],
        ],
        body: tableData,
        styles: { fontSize: 9 },
        theme: "grid",
        headStyles: { fillColor: [16, 144, 191], textColor: 255 },
        margin: { left: margin, right: margin },
      });

      doc.save(`LoanCard_${loan.loanAccountNumber || loan.loanNumber}.pdf`);
    }
  };

  if (loading || loadingloan)
    return <div className="AdminLoanCardPage-loading">Loading...</div>;
  if (error || errorloan)
    return (
      <div className="AdminLoanCardPage-error">{error || errorloan}</div>
    );
  if (!loan)
    return (
      <div className="AdminLoanCardPage-empty">
        No loan found for Loan ID {loanId}
      </div>
    );

  console.log(loan);

  return (
    <div className="AdminLoanCardPage-container">
      {/* HEADER */}
      <header className="AdminLoanCardPage-header">
        <div className="LoanCard-logo-container">
          {company?.logoUrl && (
            <img src={company.logoUrl} alt="Logo" className="LoanCard-logo" />
          )}
        </div>

        <div className="LoanCard-company-info-right">
          <h2 className="company-name">{company?.name || "Company Name"}</h2>
          {company?.cin && <p><strong>CIN:</strong> {company.cin}</p>}
          {company?.address && <p><strong>Regt. Office:</strong>{company.address}</p>}
          {company?.email && <p><strong>Email:</strong> {company.email}</p>}
          {company?.contact && <p><strong>Contact:</strong> {company.contact}</p>}
        </div>

        <div  style={{ opacity: 0 }} className="LoanCard-logo-container">
          {company?.logoUrl && (
            <img src={company.logoUrl} alt="Logo" className="LoanCard-logo" />
          )}
        </div>
        
      </header>

      <div className="LoanCard-title-center">
        <h3>Loan Card</h3>
      </div>

      {/* Loan & Customer Details */}
      <section className="AdminLoanCardPage-details">
        <div><strong>Customer Name:</strong> {loan.userName}</div>
        <div><strong>customer Id:</strong> {loan.customerId || "NA"}</div>

        {/* <div><strong>Guardian Name:</strong> {loan.guardianName || "NA"}</div> */}
        <div><strong>Loan Number:</strong> {loan.loanAccountNumber}</div>
        {/* <div><strong>Branch:</strong> {loan.branchName || "NA"}</div> */}
        {/* <div><strong>Contact No:</strong> {loan.contactNo || "-"}</div> */}
        <div><strong>Plan Name:</strong> {loan.loanType || loan.planName || "NA"}</div>
        <div><strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}</div>
        <div><strong>EMI Amount:</strong> {formatAmount(emiAmountFromSchedule)}</div>
        <div><strong>Number of EMI:</strong> {emis.length}</div>
        <div><strong>Exit Amount:</strong> {formatAmount(loan.loanPayable)}</div>
      </section>

      {/* EMI Schedule */}
      <section className="AdminLoanCardPage-table">
        <h2 className="loan-card-page-header">EMI Schedule</h2>
        <table>
          <thead>
            <tr>
              <th>EMI No</th>
              <th>Due Date</th>
              <th>Principal</th>
              <th>Interest</th>
              <th>EMI Amount</th>
              <th>Payment Date</th>
              <th>Staff Sign</th>
              <th>Customer Sign</th>
            </tr>
          </thead>
          <tbody>
            {emis.map((emi, index) => (
              <tr key={emi.id}>
                <td>{index + 1}</td>
                <td>{formatDate(emi.dueDate)}</td>
                <td>{formatAmount(emi.principalComponent)}</td>
                <td>{formatAmount(emi.interestComponent)}</td>
                <td>{formatAmount(emi.emiAmount)}</td>
                <td>{emi.paymentDate ? formatDate(emi.paymentDate) : "-"}</td>
                <td></td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* Download Button */}
      <div className="AdminLoanCardPage-btn-wrapper">
        <button
          className="AdminLoanCardPage-download-btn"
          onClick={downloadPageAsPDF}
        >
          📥 Download PDF
        </button>
      </div>
    </div>
  );
};

export default LoanCardPage;
